import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { MobileView, BrowserView, isTablet } from 'react-device-detect'
import { Row, Col, Card, List, Checkbox, Collapse } from 'core/components/ui'
import SVG from 'core/components/svg'
import { getCurrency } from 'core/utils/cultures/unit'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import { configuratorShape } from '../../shapes'

const { Panel } = Collapse

const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark3};
  font-weight: ${font.weight.base};
`

const ColDataValue = styled(Col)`
  text-align: right;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
`

const InteriorTitle = styled.h5`
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgsm};
`
const ClickableRow = styled(Row)`
  cursor: pointer;
`

const InteriorIcon = styled(SVG)`
  width: 40px;
  fill: ${props => props.theme.colors.color2.bg};
  margin-right: 10px;
`
const Design = props => {
  const { configurator, setConfigurator, loading } = props
  const { designList, design } = configurator

  const handleOnChangeSelectionInterior = item => {
    const { interior } = design

    const isSelected = !interior ? false : interior.filter(el => el.id === item.id).length > 0

    let extendedInteriors = interior ? [...interior] : []

    if (!isSelected) {
      extendedInteriors.push(item)
    } else {
      extendedInteriors = interior.filter(el => el.id !== item.id)
    }

    setConfigurator({
      ...configurator,
      design: {
        ...configurator.design,
        interior: extendedInteriors
      }
    })
  }

  const renderInterior = () => {
    const { interior } = designList
    const { leathers, fabrics } = interior
    const interiorSelected = design.interior

    const renderList = dataSource => (
      <List
        loading={loading}
        dataSource={dataSource}
        renderItem={item => (
          <List.Item>
            <ClickableRow
              type="flex"
              style={{ width: '100%' }}
              align="top"
              gutter={16}
              onClick={() => handleOnChangeSelectionInterior(item)}
            >
              <ColDataInput span={2}>
                <Checkbox
                  checked={
                    !interiorSelected
                      ? interiorSelected
                      : interiorSelected.filter(el => el.id === item.id).length > 0
                  }
                />
              </ColDataInput>

              <ColDataLabel span={18}>{item.label}</ColDataLabel>
              <ColDataValue span={4}>
                {!item.serial ? (
                  <>
                    <FormattedMessage
                      id="configurator-design-card-1-price"
                      values={{ price: item.price }}
                    />{' '}
                    {getCurrency()}
                  </>
                ) : (
                  <FormattedMessage id="configurator-design-card-1-included" />
                )}
              </ColDataValue>
            </ClickableRow>
          </List.Item>
        )}
      />
    )

    return (
      <>
        {!isTablet && (
          <BrowserView>
            <Card bordered={false}>
              <Row type="flex" align="top" gutter={40}>
                <Col lg={12} xs={24}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <InteriorIcon svg={svg.leather} />
                    </Col>
                    <Col>
                      <InteriorTitle>
                        <FormattedMessage id="configurator-design-card-2-title-1" />
                      </InteriorTitle>
                    </Col>
                  </Row>
                  {renderList(leathers)}
                </Col>
                <Col lg={12} xs={24}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <InteriorIcon svg={svg.fabric} />
                    </Col>
                    <Col>
                      <InteriorTitle>
                        <FormattedMessage id="configurator-design-card-2-title-2" />
                      </InteriorTitle>
                    </Col>
                  </Row>
                  {renderList(fabrics)}
                </Col>
              </Row>
            </Card>
          </BrowserView>
        )}
        <MobileView>
          <Collapse expandIconPosition="right" bordered={false}>
            <Panel header={<FormattedMessage id="configurator-design-card-2-title-1" />}>
              {renderList(leathers)}
            </Panel>
          </Collapse>
          <Collapse expandIconPosition="right" bordered={false}>
            <Panel header={<FormattedMessage id="configurator-design-card-2-title-2" />}>
              {renderList(fabrics)}
            </Panel>
          </Collapse>
        </MobileView>
      </>
    )
  }

  return <>{renderInterior()}</>
}

Design.propTypes = {
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  loading: PropTypes.bool.isRequired
}

export default Design
